import { createContext } from "react";

export interface TabsContextValue {
  activeTabIndex: number;
  setActiveTab: (index: number) => void;
}

export const TabsContext = createContext<TabsContextValue>({
  activeTabIndex: 0,
  setActiveTab: () => {},
});
